<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <h1>Living DNA Store</h1>

            <!-- 70 30 col row starts here -->
            <div class="blood-details-grid-row">
              <div>
                <!-- another row -->
                <div class="row">
                  <div class="col-lg-7 col-md-6">
                    <div class="image-details-row">
                      <img class="aspect-3-2" v-if="productData?.product_photo?.length > 0" :src="productData?.thumbnail_image[0]?.url" alt="" />
                      <div class="image-container-row-details">
                        <div v-for="(img, index) in productData?.thumbnail_image" :key="index">
                          <img :src="img.url" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-md-6">
                    <div class="image-content-row">
                      <h3>{{ productData.product_name }}</h3>
                      <h4>{{ productData.price_string }}</h4>
                      <span v-html="productData.product_descriptor_list"></span>

                      <!-- cta container -->
                      <div class="cta-order">
                        <button @click="openModal">Order</button>
                      </div>
                      <!-- cta container -->
                    </div>
                  </div>
                </div>
                <!-- another row -->

                <PreprProductDetails :product="productData" />
              </div>
              <div>
                <PreprProductExtras :product="productData" />
              </div>
            </div>
            <!-- 70 30 col row ends here -->
          </div>
        </div>
      </section>
    </div>
    <!-- Modal component -->
    <SubscriptionModal
      :isModalVisible="isModalVisible"
      :product="productData"
      @close="closeModal"
      @openOrderModal="openOrderModal"
      @openPaymentModal="openPaymentModal"
      @openPaymentCardModal="openPaymentCardModal"
    />

    <ModalView :isVisible="isOrderVisible" :title="'Order'" @close="closeOrderModal">
      <OrderModal
        @openCheckoutModal="openCheckoutModal"
        @openPaymentModal="openPaymentModal"
        @openPaymentCardModal="openPaymentCardModal"
        :product="productData"
      />
    </ModalView>

    <CheckoutModal
      :isModalVisible="isCheckoutVisible"
      @close="closeCheckoutModal"
      @openPaymentModal="openPaymentModal"
      @openPaymentCardModal="openPaymentCardModal"
      @back="back"
      :contactDetails="contactDetails"
      :address="address"
      region="GBR"
    />

    <PaymentModal
      :isModalVisible="isPaymentVisible"
      @close="closePaymentModal"
      @order="order"
      @openPaymentCardModal="openPaymentCardModal"
      @openCheckoutModal="openCheckoutModal"
      @back="PaymentcardbackModal"
      :contactDetails="contactDetails"
      :product="productData"
    />

    <PaymentCardModal
      :isModalVisible="isPaymentCardVisible"
      :contactDetails="contactDetails"
      :product="productData"
      :delivered="delivered"
      @closeCardModal="closeCardModal"
      @closePaymentCardModal="closePaymentCardModal"
      @order="order"
      @back="PaymentbackModal"
    />
    <ModalView :isVisible="isSuccessVisible" :title="'Payment'">
      <SuccessModal :orderKey="orderKey"/>
    </ModalView>
    <ModalView :isVisible="isFailedVisible" :title="'Payment'" @close="closeFailedModal">
      <FailedModal @close="closeFailedModal" />
    </ModalView>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Header from "@/components/header/Header.vue";
import "../../../styles/pages/BloodTestDetails.scss";
import { getProductData } from "@/store/store/store";
import { useRoute, useRouter } from "vue-router";
import ModalView from "@/components/Modal/ModalView.vue";
import SubscriptionModal from "@/view/health/Blood/Modal/CollectionMethod.vue";
import OrderModal from "@/view/health/Blood/Modal/SubscriptionModal.vue";
import CheckoutModal from "@/view/health/Blood/Modal/CheckoutModal.vue";
import PaymentModal from "@/view/health/Blood/Modal/PaymentModal.vue";
import PaymentCardModal from "@/view/health/Blood/Modal/PaymentCard.vue";
import FailedModal from './Modal/FailedModal.vue';
import SuccessModal from "./Modal/SuccessModal.vue";
import PreprProductDetails from "@/components/store/PreprProductDetails.vue";
import PreprProductExtras from "@/components/store/PreprProductExtras.vue";

const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);
const isOrderVisible = ref(false);
const isCheckoutVisible = ref(false);
const isPaymentVisible = ref(false);
const isPaymentCardVisible = ref(false);

const productData = ref({});
const address = ref({});
const loadingStatus = ref("loading");
const contactDetails = ref({});
const delivered = ref({});
const isSuccessVisible = ref(false);
const isFailedVisible = ref(false);
const orderKey = ref("");

getProductData(route.params.product).then((res) => {
  // Blood tests are no longer sold: an old link to one shows the customer's results instead.
  if (res?.product_type === "Blood Test") {
    router.replace({ name: "bloodTest" });
    return;
  }
  productData.value = res;
  loadingStatus.value = "loaded";  
});
const PaymentcardbackModal = () => {
  isCheckoutVisible.value = true;
  isPaymentVisible.value = false;
}
const PaymentbackModal = () => {
  isPaymentVisible.value = true;
  isPaymentCardVisible.value = false;
}
const back = () => {
  isOrderVisible.value = true;
  isCheckoutVisible.value = false;
}
const openModal = () => {
  isModalVisible.value = true;
}
const closeModal = () => {
  isModalVisible.value = false;
}
const openOrderModal = (value =  null) => {
  if(value  === 'Genetic Test'){
    isCheckoutVisible.value = true;
  }
  else{
    isOrderVisible.value = true;
  }
}
const closeOrderModal = () => {
  isOrderVisible.value = false;
}
const openCheckoutModal = (value = {}) => {
  contactDetails.value = {
    ...contactDetails.value,
    ...value
  };
  isCheckoutVisible.value = true;
  isPaymentVisible.value = false;

}
const closeCheckoutModal = () => {
  isCheckoutVisible.value = false;
}
const openPaymentModal = (value) => {
  contactDetails.value = {
    ...contactDetails.value,
    ...value                
  };
  delivered.value = value;
  isPaymentVisible.value = true;
  isCheckoutVisible.value = false;
}
const closePaymentModal = () => {
  isPaymentVisible.value = false;
}
const closeFailedModal = () => {
  isFailedVisible.value = false;
}
const openPaymentCardModal = (updatedContactDetails) => {
  isPaymentCardVisible.value = true;
  isPaymentVisible.value = false;
  contactDetails.value = updatedContactDetails;
};
const order = (value = null) => {
  if (!value) return;
  const resolvedOrderKey =
    value?.order?.orderKey ||
    value?.orderKey ||
    value?.data?.order?.orderKey ||
    value?.data?.orderKey ||
    null;

  if (resolvedOrderKey) {
    orderKey.value = resolvedOrderKey;
  }

  isPaymentVisible.value = false;
  isPaymentCardVisible.value = false;
  isFailedVisible.value = false;
  isSuccessVisible.value = true;
};
const closeCardModal = () => {
  isPaymentCardVisible.value = false;
}
const closePaymentCardModal = (value) => {
  isPaymentCardVisible.value = false;
  
  if (value?.paymentIntent?.status == "succeeded") {
    isSuccessVisible.value = true;
  } else {
    isFailedVisible.value = true;
  }
};

</script>
<style lang="scss">
.aspect-3-2{
  aspect-ratio: 3/2;
  object-fit: cover;
  object-position: top;
}
</style>
